import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import MainFont from 'ui/typography/mainFont';
import { RegexpType, validator } from 'utils/validator';

// eslint-disable-next-line import/no-cycle
import { Icon, Tooltip } from 'ui/atoms';
import { CustomDropDown, CustomInput, CustomRadio } from '..';
import {
  FormInputContainer,
  HeaderContainer,
  Label,
  IconContainer,
  FormInputExternalContainer
} from './style';
import theme from '../../theme';

const mandatoryFieldsLabels = [
  'address',
  'company_legal_name',
  'email_placeholder',
  'zip',
  'city',
  'name',
  'surname',
  'phone_number',
  'prefix',
  'brand'
];

const FormInput = props => {
  const {
    label,
    type,
    value,
    readonly,
    visible,
    isLeadDetail,
    isEditing,
    truncateText,
    onFocus,
    onChange,
    isDeletable,
    onDeleteClick,
    setError
  } = props;

  const { t } = useTranslation();
  //const [previousValue, setPreviousValue] = useState('');
  const [newValue, setNewValue] = useState('');
  const [currentError, setCurrentError] = useState('');

  useEffect(() => {
    if (setError) setError(!!currentError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentError]);

  useEffect(() => {
    if (onChange) {
      setCurrentError(validateFields());
      onChange(newValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newValue]);

  const renderType = () => {
    switch (type) {
      case 'boolean':
        return <CustomRadio {...props} />;
      case 'dropdown':
        return (
          <CustomDropDown
            {...props}
            handleValue={e => {
              setNewValue(e);
              if (onChange && e.value !== '-') {
                onChange(e?.value);
              }
            }}
            value={
              typeof newValue === 'object' &&
              Object.getPrototypeOf(newValue) === Object.prototype &&
              newValue.label
                ? newValue.label
                : newValue
            }
            isEditing={isEditing}
            placeholder={newValue ? null : '-'}
          />
        );
      default:
        // eslint-disable-next-line react/jsx-props-no-spreading
        return (
          <>
            <div data-tip={value} data-for={value}>
              <CustomInput
                {...props}
                value={
                  truncateText
                    ? `${newValue.substring(0, truncateText)}...`
                    : newValue
                }
                onChange={event => {
                  setNewValue(event);
                }}
                placeholder={newValue ? null : '-'}
              />
            </div>
            {truncateText && <Tooltip id={value} />}
          </>
        );
    }
  };

  const validateFields = () => {
    if (label === 'fiscal_code' && newValue) {
      if (!validator(RegexpType.FISCAL_CODE, newValue)) {
        return 'invalid_fiscal_code';
      }
    }
    if (label === 'vin' && newValue && newValue.length !== 17) {
      return 'error_vin';
    }
    if (label === 'delivery_date' && newValue) {
      if (!validator(RegexpType.VEHICHLEDELIVERY, newValue)) {
        return 'error_delivery_date';
      }
    }
    if (
      (!newValue || newValue?.length === 0) &&
      mandatoryFieldsLabels.includes(label)
    ) {
      return 'can_not_be_empty';
    }
    return '';
  };

  useEffect(() => {
    setNewValue(value);
  }, [value]);

  /* useEffect(() => {
    setPreviousValue(value);
  }, [arrayData, value]); */

  return (
    <FormInputExternalContainer>
      {visible && (
        <FormInputContainer
          className="form-inputs"
          type={type}
          readonly={readonly}
          isLeadDetail={isLeadDetail}
          onClick={onFocus}
        >
          <HeaderContainer>
            <Label type={type} isEditing={isEditing}>
              <MainFont configuration={{ fontSize: 12, lineHeight: '1.33' }}>
                {t(label)}
              </MainFont>
            </Label>
            {!readonly && isDeletable && (
              <IconContainer onClick={onDeleteClick} isEditing={isEditing}>
                <Icon
                  type="icon-close"
                  color={theme().colors.mainBlue}
                  size={14}
                />
              </IconContainer>
            )}
          </HeaderContainer>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          {renderType()}
          {/*!readonly && (!valid || typeof valid === 'string') && value && (
            <Error>
              <MainFont type="error">{valid || 'Error'}</MainFont>
            </Error>
          )*/}
        </FormInputContainer>
      )}
      {currentError && <MainFont type="errorLabel">{t(currentError)}</MainFont>}
    </FormInputExternalContainer>
  );
};

FormInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  type: PropTypes.string,
  valid: PropTypes.bool,
  readonly: PropTypes.bool,
  precompiled: PropTypes.bool,
  visible: PropTypes.bool,
  labelFromBe: PropTypes.string,
  truncateText: PropTypes.number,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  isDeletable: PropTypes.bool,
  onDeleteClick: PropTypes.func,
  setError: PropTypes.func
};

FormInput.defaultProps = {
  readonly: false,
  valid: true,
  isNewValue: false
};

export default FormInput;
